import React from 'react';
import { Popconfirm, message, Divider } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import ManageAdd from './components/ManageAdd';
import { postFrom, config } from '../../axios';
import { dicMerchantStatus } from '../../axios/dictionaries';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: {
                departmentId: '', //部门id
                keyword: '', //关键字
                name: '', //姓名
                phone: '', //手机号
                pageSize: 10
            }, //搜索参数
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
            createOrEdit: false, //默认为创建
            optionData: [], //部门信息
        }
        this.handleNewAdd = this.handleNewAdd.bind(this)
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
            createOrEdit,
            optionData,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="g-1-2" type="primary" icon="plus" onClick={this.handleNewAdd}>新增</AuthButton>
                    </div>
                    <SuperForm
                        data={searchData(optionData)}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    // showCancel={false}
                    />
                </div>
                <TableDOM
                    columns={columns({ current, handleEdit: this.handleEdit, handleDelete: this.handleDelete })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
                <ManageAdd
                    onRef={ref => this.manageAddRef = ref}
                    visible={showAddModal}
                    handlecreateOrEdit={createOrEdit}
                    handleGetList={this.handleSearch}
                    optionData={optionData}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                />
            </PageWrap>
        )
    }

    componentDidMount() {
        this.handleSearch();
        this.findDepartmentList();
    }

    handleNewAdd() { //新增
        this.setState({ showAddModal: true, createOrEdit: false })
        this.manageAddRef.loadRole();
        this.manageAddRef.initPack(true); //true: 密码类型
    }

    handleEdit = (id) => { //编辑
        this.setState({ showAddModal: true, createOrEdit: true })
        this.manageAddRef.loadPack({ id })
        this.manageAddRef.loadRole();
        this.manageAddRef.initPack(false);
    }

    handleDelete = (id) => { //删除

        this.setState({ loading: true });
        let data = { employeeId: id };
        postFrom({
            url: config.API_employee_delEmployee,
            data,
        }).then(res => {
            this.setState({ loading: false });
            if (res && res.code) {
                message.error(res.message || '接口异常');
                return;
            }
            this.handleSearch();
            message.success(`删除成功`);
        }).catch(err => {
            this.setState({ loading: false });
        })
    }

    handleSearch = (values = {}) => { //表单搜索/分页

        let { params, current } = this.state;
        let data = {};
        values.departmentId = values.departmentId == -1 ? '' : values.departmentId;
        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({
            url: config.API_employee_findPage,
            data,
        }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    findDepartmentList = () => { //部门信息列表

        this.setState({ tableLoading: true });
        let result = [];
        postFrom({
            url: config.API_department_findDepartmentList
        }).then(res => {
            for (let key in res) {
                result.push({
                    title: res[key]['name'],
                    value: res[key]['id'],
                    status: res[key]['status'],
                })
            }
            this.setState({ optionData: result, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }
}

const searchData = (optionData) => [

    {
        tagName: 'Select',
        formConfig: { name: 'departmentId' },
        attribute: { placeholder: '请选择部门', style: { width: '160px' } },
        optionData: optionData
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字 ', style: { width: '160px' } },
        title: '在姓名/手机号内模糊查询'
    },

];
const columns = ({ current, handleEdit, handleDelete }) => [

    {
        title: '部门',
        dataIndex: 'departmentName',
    },
    {
        title: '姓名',
        dataIndex: 'name',
    },
    {
        title: '电话号码(登录账号)',
        dataIndex: 'phone',
    },
    {
        title: '岗位',
        dataIndex: 'roleName',
    },
    {
        title: '使用状态',
        dataIndex: 'status',
        render(text, record, index) {
            let now = dicMerchantStatus.find(item => item.value == text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        render(text, record, index) {
            return (<div>
                { record.id===39 ?null:<AuthButton authkey="g-1-3"><span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span></AuthButton>}
                {
                        record.id===39 ?
                        null :
                        <React.Fragment>
                            <Divider type="vertical" />
                            <AuthButton authkey="g-1-4">
                                <Popconfirm placement="top" title={"确定删除吗？"} onConfirm={() => { handleDelete(record.id) }} okText="确定" cancelText="不了">
                                    <span className="showClickDetail">删除</span>
                                </Popconfirm>
                            </AuthButton>
                        </React.Fragment>
                    }

            </div>)
        }

    },
];



// WEBPACK FOOTER //
// ./src/page/Employee/Manage.js